import React, {Component} from 'react'
import {NavLink} from 'react-router-dom'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

const menu_items = [{
  label: 'Algo Manager',
  icon: 'columns',
  link: '/manager'
}, {
  label: 'Algo Builder',
  icon: 'cog',
  link: '/builder'
}, {
  label: 'Screener',
  icon: 'filter',
  link: '/stock-filters'
}, {
  label: 'Analysis',
  icon: 'chart-area',
  link: '/analysis'
}]

class Navigation extends Component {
  render() {
    return(
      <nav>
        {menu_items.map((item, index) => (
          <NavLink
            key={index}
            to={item.link}
            activeClassName='active'
          >
            <FontAwesomeIcon icon={item.icon}/> {item.label}
          </NavLink>
        ))}
      </nav>
    )
  }
}

export default Navigation
